import { IncidentModel } from './incident.model';

export class FinancialResponsibilityIncidentModel extends IncidentModel {
    public incidentFinancialResponsibilityId: number;
    public courtId = 0;
    public courtName: string;
    public courtCaseNumber: string;

    public vehiclePlateJurisdictionId: number;
    public vehiclePlateNumber: string;
}
